// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loadingDisplayMemeApprovalDashboard {
    display: block;
    width: auto;
    max-width: 35em;
    max-height: 15em;
    margin-left: auto;
    margin-right: auto;
    border-radius: 15px;
    animation: fadeInGlobal 1s;
    -webkit-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    
}
.LoadingDisplayManualApprovalDashboard {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left:auto;
    margin-right: auto;
    background-color: var(--DarkBlue);
    border-radius: 5px;
    min-height: 35em;
    max-width: 30em;
    max-height: 35em;
    margin-top: 18px;
    -webkit-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
}

.manualApprovalContainerDashboard {
    display: flex;
    flex-direction: column; /* Stack items vertically */
    align-items: center; /* Center items horizontally */
    
    background-color: var(--DarkBlue);
    border-radius: 0.75em;

    max-width: 30em;
    min-height: 35em;
    max-height: 35em;
    -webkit-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    margin-left:auto;
    margin-right: auto;
    animation: mostRecentMemeFadeIn 2s ease-in-out;
    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}
.manualApprovalDashboardDisplayTitle {
    text-align: center;
}

.manualApprovalDashboardDisplayTitleLine {
    border: none;
    width:100%;
    height: 1px;
    background-color: var(--GrayBlue);
    /* Make the background transparent */
    box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.363);
    /* Subtle shadow */
}

.manualApprovalLineDashboard {
    border: 1px solid var(--GrayBlue);
}

.manualApprovalContainerNoImageDashboard {
    min-height: 19.15em;
}

.manualApprovalContainerImageDashboard {
    padding-top: 1em;
    min-height: 15em;
    max-height: 22em;
}

.manualApprovalDashboardDisplayText {
    max-width: 20em;
    min-height: 19.15em;
}

.manualApprovalDashboardDisplayText p {
    color: var(--settingsTextColor);
    text-align: center;
    font-size: 0.8em;
}

.manualApprovalDashboardDisplayText h4 {
    color: var(--HighlightBlue);
    text-align: center;
    font-size: 1em;
}

.manualApprovalDashboardDisplayText h5 {
    color: var(--settingsTextColor);
    text-align: center;
    font-size: bold;
    font-size: 0.9em;
}

.manualApprovalDashboardToggleForDisplayText {
    font-size: 12px;
}

.manualApprovalTitleDashboard {
    margin-left: auto;
    margin-right: auto;
}

.manualApprovalDisplayNameDashboard {
    text-align: center;
    font-weight: 700;
    color: var(--HighlightBlue);
}

.manualApprovalTextDisplayDashboard {
    font-size: 0.8em;
    color: var(--settingsTextColor);
    text-align: center;
}

.manualApprovalButtonContainerDashboard {
    display: flex;
    gap: 4em;
}

@media only screen and (max-width: 768px) {
    .loadingDisplayMemeApprovalDashboard {
        max-width: 10em;
    }
   
    .manualApprovalDashboardDisplayText {
        min-height: 16em;
    }
}


`, "",{"version":3,"sources":["webpack://./src/components/Applications/memeApproval/dashboard/memeApprovalCss.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;IAC1B,uDAAuD;IACvD,oDAAoD;IACpD,+CAA+C;;AAEnD;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uDAAuD;IACvD,oDAAoD;IACpD,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,sBAAsB,EAAE,2BAA2B;IACnD,mBAAmB,EAAE,8BAA8B;;IAEnD,iCAAiC;IACjC,qBAAqB;;IAErB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uDAAuD;IACvD,oDAAoD;IACpD,+CAA+C;IAC/C,gBAAgB;IAChB,kBAAkB;IAClB,8CAA8C;IAC9C,mEAAmE;AACvE;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,WAAW;IACX,iCAAiC;IACjC,oCAAoC;IACpC,gDAAgD;IAChD,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".loadingDisplayMemeApprovalDashboard {\n    display: block;\n    width: auto;\n    max-width: 35em;\n    max-height: 15em;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 15px;\n    animation: fadeInGlobal 1s;\n    -webkit-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    -moz-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    \n}\n.LoadingDisplayManualApprovalDashboard {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-left:auto;\n    margin-right: auto;\n    background-color: var(--DarkBlue);\n    border-radius: 5px;\n    min-height: 35em;\n    max-width: 30em;\n    max-height: 35em;\n    margin-top: 18px;\n    -webkit-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    -moz-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n}\n\n.manualApprovalContainerDashboard {\n    display: flex;\n    flex-direction: column; /* Stack items vertically */\n    align-items: center; /* Center items horizontally */\n    \n    background-color: var(--DarkBlue);\n    border-radius: 0.75em;\n\n    max-width: 30em;\n    min-height: 35em;\n    max-height: 35em;\n    -webkit-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    -moz-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    margin-left:auto;\n    margin-right: auto;\n    animation: mostRecentMemeFadeIn 2s ease-in-out;\n    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n.manualApprovalDashboardDisplayTitle {\n    text-align: center;\n}\n\n.manualApprovalDashboardDisplayTitleLine {\n    border: none;\n    width:100%;\n    height: 1px;\n    background-color: var(--GrayBlue);\n    /* Make the background transparent */\n    box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.363);\n    /* Subtle shadow */\n}\n\n.manualApprovalLineDashboard {\n    border: 1px solid var(--GrayBlue);\n}\n\n.manualApprovalContainerNoImageDashboard {\n    min-height: 19.15em;\n}\n\n.manualApprovalContainerImageDashboard {\n    padding-top: 1em;\n    min-height: 15em;\n    max-height: 22em;\n}\n\n.manualApprovalDashboardDisplayText {\n    max-width: 20em;\n    min-height: 19.15em;\n}\n\n.manualApprovalDashboardDisplayText p {\n    color: var(--settingsTextColor);\n    text-align: center;\n    font-size: 0.8em;\n}\n\n.manualApprovalDashboardDisplayText h4 {\n    color: var(--HighlightBlue);\n    text-align: center;\n    font-size: 1em;\n}\n\n.manualApprovalDashboardDisplayText h5 {\n    color: var(--settingsTextColor);\n    text-align: center;\n    font-size: bold;\n    font-size: 0.9em;\n}\n\n.manualApprovalDashboardToggleForDisplayText {\n    font-size: 12px;\n}\n\n.manualApprovalTitleDashboard {\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.manualApprovalDisplayNameDashboard {\n    text-align: center;\n    font-weight: 700;\n    color: var(--HighlightBlue);\n}\n\n.manualApprovalTextDisplayDashboard {\n    font-size: 0.8em;\n    color: var(--settingsTextColor);\n    text-align: center;\n}\n\n.manualApprovalButtonContainerDashboard {\n    display: flex;\n    gap: 4em;\n}\n\n@media only screen and (max-width: 768px) {\n    .loadingDisplayMemeApprovalDashboard {\n        max-width: 10em;\n    }\n   \n    .manualApprovalDashboardDisplayText {\n        min-height: 16em;\n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
